import { useParams } from 'react-router-dom'
import { useGetAccountQuery } from '../api/client'
import NotificationConfigurationList from '../components/notifications/NotificationConfigurationList'
import SimpleLoader from '../components/SimpleLoader'
import { TextPageContainer } from '../containers/TextPageContainer'
import PageMasthead from '../components/PageMasthead'
import MastheadBreadcrumb from '../components/MastheadBreadcrumb'

type ParamTypes = {
    accountId: string
}

function NotificationConfigurationSettingsPage() {
    const { accountId } = useParams<ParamTypes>()

    const parsedAccountId = parseInt(accountId as string)

    // Load the account
    const { data: accountData, loading: accountLoading } = useGetAccountQuery({
        variables: { accountId: parsedAccountId }
    })

    const account = accountData?.getAccount

    return (
        <>
            <PageMasthead
                title="Manage notifications"
                subtitle="Create, edit and delete Courier notifications"
                tabTitle="Manage notifications"
                breadcrumb={
                    <MastheadBreadcrumb
                        to={`/account/${accountId}/settings`}
                        label="Profile settings"
                    />
                }
            />
            <TextPageContainer>
                {accountLoading && <SimpleLoader loading={true} />}
                {account && <NotificationConfigurationList account={account} />}
            </TextPageContainer>
        </>
    )
}

export default NotificationConfigurationSettingsPage
